import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { Menu, Report } from "../Components/Menu/Menu";
import { Outlet, NavLink, Link } from "react-router-dom";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import Loading from "../Components/Loading/Loading";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { userData } from "../DataContext/DataContext";
import { useRecoilState } from "recoil";
import axios from "axios";
import { authorization, UrlApi } from "../UrlApi/UrlApi";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Menus from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LogoutIcon from "@mui/icons-material/Logout";
import { AlertError } from "../Components/AlertDialog/AlertDialog";
import { Card } from "@mui/material";
import "./Main.css";
import WidgetsIcon from "@mui/icons-material/Widgets";
import { path } from "../UrlApi/UrlApi";
import DescriptionIcon from "@mui/icons-material/Description";
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';

const drawerWidth = 240;

const Body = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - 240px)`,
    zIndex: "1300",
    marginLeft: `240px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "5rem",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const menuActive = {
  marginLeft: "5px",
  height: "3.5rem",
  background: "#1676FC",
  color: "#FFFFFF",
  borderTopLeftRadius: "25px",
  borderBottomLeftRadius: "25px",
};

const stylesMenuItem = {
  fontFamily: "Sarabun",
};

export default function Main() {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [user, setUserData] = useRecoilState(userData);
  const [subMenu, setSubMenu] = useState(false);
  const [subReport, setSubReport] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dropDownMenu = Boolean(anchorEl);
  const [name, setName] = useState("");
  const [userName, setUserName] = useState("");

  const [menuData, setMenuData] = useState([]);
  const [reportData, setReportData] = useState([]);

  const getUserData = async () => {
    setLoading(true);
    const userData = await axios
      .post(UrlApi + "get_user_data", {}, authorization)
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
    if (userData) {
      if (userData.data.status === 0) {
        setLoading(false);
        AlertError(userData.data.message, () => {
          localStorage.removeItem("token");
          window.location = path + "/login";
        });
      } else {
        setUserData(userData.data);
        setName(userData.data.name);
        setUserName(userData.data.user_name);
        setLoading(false);
      }
    }
    setLoading(true);
    await axios
      .post(UrlApi + "get_menu_data", userData.data, authorization)
      .then((res) => {
        res.data.map((item, index)=>{
          switch(parseInt(item.master_main_menu_id)) {
            case 1:
              item.master_main_menu_icon = <WidgetsIcon />
              break;
            case 2:
              item.master_main_menu_icon = <FolderSharedIcon />
              break;
            case 3:
                item.master_main_menu_icon = <DashboardCustomizeIcon />
              break;
            default:
              item.master_main_menu_icon = <DescriptionIcon />
          }
        });
        setMenuData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  const logOut = async () =>{
    const ip_address = localStorage.getItem('ip_address');
    setLoading(true);
    await axios
      .post(UrlApi + "logout", {user, ip_address}, authorization)
      .then((res) => {
        localStorage.removeItem("token");
        localStorage.removeItem("ip_address");
        window.location = path + "/login";
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  }

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        style={{
          background: "#FFFFFF",
        }}
      >
        <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
          <IconButton
            color="inherit"
            onClick={() => setOpen(!open)}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none", color: "gray"}) }}
          >
            <MenuIcon sx={{ fontSize: "30px", color: "gray"}} />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={() => setOpen(!open)}
            sx={{ mr: 2, ...(open === false && { display: "none", color: "gray"}) }}
          >
            <KeyboardDoubleArrowLeftIcon sx={{color: "gray"}}/>
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: {color: "gray"} }}
          >
            DGF EXPRESS
          </Typography>
          <div>
            <IconButton
              color="inherit"
              aria-controls={dropDownMenu ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={dropDownMenu ? "true" : undefined}
              onClick={(e) => setAnchorEl(e.currentTarget)}
              edge="end"
              sx={{ mr: 2 }}
            >
              <AccountCircleIcon
                sx={{ fontSize: "35px", marginRight: "5px", color: 'gray'}}
              />
              <label style={{ color: "gray", fontSize: "16px" }}>
                {name}
              </label>
            </IconButton>
            <Menus
              anchorEl={anchorEl}
              open={dropDownMenu}
              onClose={() => setAnchorEl(null)}
              style={{ zIndex: "1301" }}
            >
              <MenuItem onClick={() => {}} style={stylesMenuItem}>
                ผู้ใช้งาน : {userName}
              </MenuItem>
              <MenuItem onClick={() => {}} style={stylesMenuItem}>
                ชื่อผู้ใช้ : {name}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  logOut();
                }}
              >
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{
                    fontFamily: "Sarabun",
                    fontWeight: "bold",
                  }}
                >
                  ออกจากระบบ
                </ListItemText>
              </MenuItem>
            </Menus>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            background: "linear-gradient(180deg, #1676FC 0%, #0D47A1 100%)",
            color: "#FFFFFF",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <div style={{marginTop: "3.5rem"}}>
        {menuData.map((item, inx)=>{
        return (
          <div>
              <List>
                <ListItemButton
                  onClick={() => {
                    setSubMenu(!subMenu);           
                    item.master_sub_menu_active = !item.master_sub_menu_active;
                  }}
                  style={menuActive}
                >
                  <ListItemIcon style={{ color: "#FFFFFF"}}>
                    {item.master_main_menu_icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.master_main_menu_name}
                    primaryTypographyProps={{
                      fontSize: "16px",
                      fontFamily: "Sarabun",
                    }}
                  />
                  {item.master_sub_menu_active ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                   <Collapse in={item.master_sub_menu_active} timeout="auto" unmountOnExit>
                    <List component="div">
                    {item.sub_menu_data.map((itemList, index) => (
                          <ListItem
                            component={NavLink}
                            to={itemList.master_menu_path}
                            id={itemList.master_menu_id}
                            key={index}
                          >
                            <ListItemText
                              primary={itemList.master_menu_name}
                              style={{ marginLeft: "10px" }}
                              primaryTypographyProps={{
                                fontFamily: "Sarabun",
                                fontSize: "14px",
                              }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
              </List>
            <Divider />
          </div>
        )
        })}
        </div>
        {/* <List>
            <ListItemButton
              onClick={() => setSubReport(!subReport)}
              style={menuActive}
            >
              <ListItemIcon style={{ color: "#FFFFFF" }}>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText
                primary="รายงาน"
                primaryTypographyProps={{
                  fontSize: "16px",
                  fontFamily: "Sarabun",
                }}
              />
              {subReport ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          <Collapse in={subReport} timeout="auto" unmountOnExit>
            <List component="div">
              {reportData.map((item, index) => (
                <ListItem
                  component={NavLink}
                  to={item.master_menu_path}
                  id={item.master_menu_id}
                  key={index}
                >
                  <ListItemText
                    primary={item.master_menu_name}
                    style={{ marginLeft: "10px" }}
                    primaryTypographyProps={{
                      fontFamily: "Sarabun",
                      fontSize: "14px",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Collapse>
        </List> */}
      </Drawer>
      <Body
        open={open}
        style={{ width: "80%", background: "#F0F4F4", height: "100vh"}}
      >
        <Toolbar />
        <Outlet />
      </Body>
      <Loading open={loading} />
    </Box>
  );
}
